import { createGlobalStyle } from 'styled-components';
import { media } from './theme';

const GlobalStyle = createGlobalStyle`
  html {
    /* 给 rem / 浏览器缩放一个明确基准 */
    font-size: 16px;
    /* 防止 iOS 旋转到横屏时自动放大正文字号 */
    -webkit-text-size-adjust: 100%;
  }

  body {
    margin: 0;
    padding: 0;
    padding-top: 56px; /* 为固定 Navbar 留出空间 */
    /* 统一字体来源（此前 GlobalStyle 用 system 字体、App.css 用 Roboto，二者冲突） */
    font-family: 'Roboto', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }

  * {
    box-sizing: border-box;
  }

  /* 手机上所有表单控件 ≥16px，规避 iOS Safari 聚焦输入时自动放大整页（最常见的"App 感"破绽）。
     全站一处生效，覆盖所有页面与弹窗里的 input/select/textarea。 */
  ${media.phone} {
    input,
    select,
    textarea {
      font-size: 16px;
    }
  }
`;

export default GlobalStyle;
